@if (render) {
    <div class="standardTable">
        <table>
            <thead>
                <tr>
                    <td [style.width.px]="300">Status</td>
                    <td [style.width.px]="100">Code</td>
                    <td [style.width.px]="300">Name</td>
                    @if (lotBuildProgrammeEvents.hasSummaries) {
                        <td [style.width.px]="50">Lot Number</td>
                    }
                    <td [style.width.px]="300">Supplier</td>
                    <td [style.width.px]="150">Start Date</td>
                    <td [style.width.px]="150">End Date</td>
                    <td [style.width.px]="50">Duration</td>
                    <td [style.width.px]="50">PO Total</td>
                    <td></td>
                </tr>
            </thead>
            <tbody
                cbTableBody
                cdkDropList
                [id]="'stage-drop-list-' + buildProgrammeStage.buildStageId"
                [cdkDropListConnectedTo]="connectedDropListIds"
                [cdkDropListDisabled]="
                    !lotBuildProgrammeActionBar.reorderingEnabled ||
                    (lotBuildProgrammeEvents.hasSummaries && buildProgrammeStage?.buildStageId > 0)
                "
                (cdkDropListDropped)="onDrop($event)"
            >
                @if (
                    buildProgrammeStage?.buildStageId > 0 && lotBuildProgrammeEvents.hasSummaries
                ) {
                    @for (activity of getBlockActivities(); track activity) {
                        <cb-lot-build-programme-activity-row
                            class="table-row"
                            [id]="'buildProgrammeActivity_' + activity.id"
                            [ngClass]="activityRowClasses(activity, highlightedActivityId)"
                            [activity]="activity"
                            [lotDto]="lotDto"
                            [displayUnitNumber]="true"
                            [downloadOnly]="activity.isActivityFromUnit"
                            cdkDrag
                            cdkDragPreviewClass="cb-table-drag-preview"
                            [cdkDragDisabled]="
                                !lotBuildProgrammeActionBar.reorderingEnabled ||
                                activity.isControlledByParentLot ||
                                activity.statusId === BUILD_PROGRAMME_ACTIVITY_STATUS_ENUM.Abandoned
                            "
                        >
                        </cb-lot-build-programme-activity-row>
                    }
                    @for (summary of summaries; track summary) {
                        @if (getSummaryActivties(summary.buildActivityId).length > 0) {
                            <tr
                                [id]="
                                    'buildActivitySummary_' +
                                    buildProgrammeStage?.buildStageId +
                                    '_' +
                                    summary.buildActivityId
                                "
                            >
                                <td class="actions"></td>
                                <td>
                                    <strong>{{ summary?.code | cbDasher }}</strong>
                                </td>
                                <td>
                                    <strong>{{ summary?.name | cbDasher }}</strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td>
                                    <span [matTooltip]="summary?.startDate | date:'fullDate'">
                                        <strong>{{ summary?.startDate | date }}</strong>
                                    </span>
                                </td>
                                <td>
                                    <span [matTooltip]="summary?.endDate | date:'fullDate'">
                                        <strong>{{ summary?.endDate | date }}</strong>
                                    </span>
                                </td>
                                <td></td>
                                <td class="actions">
                                    <button
                                        mat-icon-button
                                        (click)="
                                            summaryExpanded[summary.buildActivityId] =
                                                !summaryExpanded[summary.buildActivityId]
                                        "
                                    >
                                        <mat-icon>
                                            {{
                                                summaryExpanded[summary.buildActivityId]
                                                    ? 'keyboard_arrow_up'
                                                    : 'keyboard_arrow_down'
                                            }}
                                        </mat-icon>
                                    </button>
                                </td>
                            </tr>
                            @if (summaryExpanded[summary.buildActivityId]) {
                                @for (
                                    activity of getSummaryActivties(summary.buildActivityId);
                                    track activity
                                ) {
                                    <cb-lot-build-programme-activity-row
                                        class="table-row"
                                        [id]="'buildProgrammeActivity_' + activity.id"
                                        [ngClass]="
                                            activityRowClasses(activity, highlightedActivityId)
                                        "
                                        [activity]="activity"
                                        [lotDto]="lotDto"
                                        [displayUnitNumber]="true"
                                        [downloadOnly]="activity.isActivityFromUnit"
                                        cdkDrag
                                        cdkDragPreviewClass="cb-table-drag-preview"
                                        [cdkDragDisabled]="
                                            !lotBuildProgrammeActionBar.reorderingEnabled ||
                                            activity.isControlledByParentLot ||
                                            activity.statusId ===
                                                BUILD_PROGRAMME_ACTIVITY_STATUS_ENUM.Abandoned
                                        "
                                    >
                                    </cb-lot-build-programme-activity-row>
                                }
                            }
                        }
                    }
                } @else {
                    @for (activity of activities; track activity) {
                        <cb-lot-build-programme-activity-row
                            class="table-row"
                            [id]="'buildProgrammeActivity_' + activity.id"
                            [ngClass]="activityRowClasses(activity, highlightedActivityId)"
                            [activity]="activity"
                            [lotDto]="lotDto"
                            cdkDrag
                            cdkDragPreviewClass="cb-table-drag-preview"
                            [cdkDragDisabled]="
                                !lotBuildProgrammeActionBar.reorderingEnabled ||
                                activity.isControlledByParentLot ||
                                activity.statusId === BUILD_PROGRAMME_ACTIVITY_STATUS_ENUM.Abandoned
                            "
                        >
                        </cb-lot-build-programme-activity-row>
                    }
                }
                @if (!loaded) {
                    <tr>
                        <td [attr.colspan]="lotBuildProgrammeEvents.hasSummaries ? '9' : '8'">
                            <cb-loading-spinner></cb-loading-spinner>
                        </td>
                    </tr>
                }
                @if (loaded && (!activities || activities?.length === 0)) {
                    <tr>
                        <td [attr.colspan]="lotBuildProgrammeEvents.hasSummaries ? '9' : '8'">
                            <cb-info-message
                                [message]="'There are no Activities to display'"
                                [icon]="'info_circle'"
                            ></cb-info-message>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
}
